// import axiosClient from '../axiosClient';

// export const categoryApi = {
//   getCategoryData: async (financialYear) => {
//     try {
//       const params = new URLSearchParams({
//         financialYear: financialYear
//       });

//       console.log('📊 Fetching category data for FY:', financialYear);

//       const data = await axiosClient.get(`/category-sales?${params.toString()}`);
      
//       console.log('📊 Category API data:', data);
      
//       return data;
//     } catch (error) {
//       console.error('Error fetching category data:', error);
//       throw error;
//     }
//   }
// };


// src/api/home/categoryApi.js
import axiosClient from '../axiosClient';

export const categoryApi = {
    getCategoryData: async (financialYear, filters = {}) => {
        try {
            const params = new URLSearchParams({ financialYear });

            if (filters.customer) {
                filters.customer.split(',').forEach(v => { if (v.trim()) params.append('customer', v.trim()); });
            }
            if (filters.category) {
                filters.category.split(',').forEach(v => { if (v.trim()) params.append('category', v.trim()); });
            }
            if (filters.salesEmployee) {
                filters.salesEmployee.split(',').forEach(v => { if (v.trim()) params.append('salesEmployee', v.trim()); });
            }
            if (filters.contactPerson) {
                filters.contactPerson.split(',').forEach(v => { if (v.trim()) params.append('contactPerson', v.trim()); });
            }
            if (filters.itemCode) {
                filters.itemCode.split(',').forEach(v => { if (v.trim()) params.append('itemCode', v.trim()); });
            }

            console.log('📊 Fetching category data | FY:', financialYear, '| Filters:', filters);

            const response = await axiosClient.get(`/category-sales?${params.toString()}`);
            console.log('📊 Category API response:', response);
            return response;
        } catch (error) {
            console.error('Error fetching category data:', error);
            throw error;
        }
    },

    getCategorySalesForFY: async (customerCode, startYear, endYear) => {
        const params = new URLSearchParams({ startYear, endYear });
        const data = await axiosClient.get(`/customers/category-sales-fy/${customerCode}?${params}`);
        return data;
        }
};